import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { Pill } from 'components/Pill/Pill'
import { useCurrentPlan } from 'hooks/useCurrentPlan'
import { useMemo } from 'react'

export const PlanBadge = () => {
  const { data } = useCurrentPlan()

  const label = useMemo<string | null>(() => {
    const plan = data?.plan
    switch (plan) {
      case PaymentPlanKey.BlazeAutopilotStarter:
        return 'Starter'
      case PaymentPlanKey.BlazeAutopilotGrowth:
        return 'Growth'
      case PaymentPlanKey.Free:
        return 'Free'
      case PaymentPlanKey.VirtualMarketer:
      default:
        return null
    }
  }, [data])

  return label ? <Pill>{label}</Pill> : null
}
